<template>
  <el-form
    class="login-form"
    status-icon
    :rules="loginRules"
    ref="form"
    :model="form"
    label-width="0"
  >
    <!-- <el-form-item v-if="tenantMode" prop="tenantId">
      <el-input size="small"
                @keyup.enter.native="handleLogin"
                v-model="form.tenantId"
                auto-complete="off"
                placeholder="请输入租户ID">
        <i slot="prefix" class="icon-quanxian"/>
      </el-input>
    </el-form-item> -->
    <el-form-item prop="username">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        v-model="form.username"
        auto-complete="username"  
        name="username"           
        placeholder="请输入账号"
        @blur="handleUsernameBlur"
        @change="handleUsernameChange"
      >
      <!-- :readonly='readonly'
        @focus="readonly=false"
        autocomplete="off" -->
        <i slot="prefix">
          <img class="img" :src="userIcon" alt="">
        </i>
      </el-input>
    </el-form-item>

    <!-- 角色选择下拉框 -->
    <el-form-item prop="roleId" >
      <el-select
        size="small"
        v-model="form.roleId"
        placeholder="请选择角色"
        style="width: 325px;"
      >
        <el-option
          v-for="role in roleList"
          :key="role.TEAM_ID"
          :label="role.TEAM_NAME"
          :value="role.TEAM_ID"
        />
      </el-select>
    </el-form-item>

    <el-form-item prop="password">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        :type="passwordType"
        v-model="form.password"
        auto-complete="current-password"  
        name="password"                   
        placeholder="请输入密码"
      >
      <!-- :readonly='readonly'
        @focus="readonly=false"
        autocomplete="off" -->
        <i slot="prefix">
          <img class="img" :src="passwordIcon" alt="">
        </i>
        <i
          class="el-icon-view el-input__icon"
          slot="suffix"
          @click="showPassword"
        />
      </el-input>
    </el-form-item>
    <el-form-item prop="code" v-if="failures>=userRule.enbleCaptcha">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            size="small"
            @keyup.enter.native="handleLogin"
            v-model="form.code"
            auto-complete="off"
            placeholder="请输入验证码"
          >
            <i slot="prefix">
              <img class="img" :src="codeIcon" alt="">
            </i>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img
              :src="form.image"
              class="login-code-img"
              @click="refreshCode"
            />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="small"
        @click.native.prevent="handleLogin"
        class="login-submit"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapGetters } from "vuex";
// import {info} from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";
import { getUserRule,getTeamListByUsername,getUserInfo,saveTeamIdToRedis } from "@/api/system/user";
import { getStore,setStore } from '@/util/store';
export default {
  name: "userlogin",
  data() {
    return {
      readonly:true,
      verCode: false,
      tenantMode: this.website.tenantMode,
      form: {
        //租户ID
        tenantId: "000000",
        //用户名
        username: "",
        //密码
        password: "",
        //账号类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image:
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        roleId: "",  // 新增角色ID字段
      },
      loginRules: {
        tenantId: [
          { required: false, message: "请输入租户ID", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        roleId: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
      },
      passwordType: "password",
      userIcon:require("@/assets/personal.svg"),
      passwordIcon:require("@/assets/password.svg"),
      codeIcon:require("@/assets/verification-code.svg"),
      enterNumber:0,//回车次数
      time:"",
      // 角色列表
      roleList: [],
      // 加载状态
      loadingRoles: false,
    };
  },
  async created() {
    //await this.getRule();
    // 定时器
    this.functionUse();
  },
  mounted() {},
  computed: {
    ...mapGetters(["tagWel","userInfo","failures","userRule"]),
  },
  props: [],
  methods: {
    //新增：用户名失去焦点事件
    handleUsernameBlur() {
      if (this.form.username) {
        this.fetchRolesByUsername();
      } else {
        this.roleList = [];
        this.form.roleId = "";
      }
    },
    //新增：用户名变化事件
    handleUsernameChange() {
      this.form.roleId = "";
      if (this.form.username) {
        this.fetchRolesByUsername();
      } else {
        this.roleList = [];
        this.form.roleId = "";
      }
    },
    // 获取角色列表方法：
    async fetchRolesByUsername() {
      try {
        this.loadingRoles = true;
        const params = {
          username: this.form.username,
        };
        // 调用后端接口获取角色列表
        const response = await getTeamListByUsername(this.form.username);
        console.log(response.data.data);
        this.roleList = response.data.data || [];
        // 如果只有一个角色，自动选中
        // if (this.roleList.length === 1) {
        //   this.form.roleId = this.roleList[0].TEAM_ID;
        // }
      } catch (error) {
        console.error('获取角色列表失败:', error);
        this.$message.error('获取角色列表失败，请稍后重试');
        this.roleList = [];
      } finally {
        this.loadingRoles = false;
      }
    },
    functionUse(){
      clearInterval(this.time);
      this.timeInterval();
    },
    timeInterval(){
      this.time = setInterval(() => {
        console.log(new Date().getTime() - getStore({name:"userRule"}).verCodeTime);
        if(getStore({name:"userRule"}).verCodeTime&&new Date().getTime() - new Date(getStore({name:"userRule"}).verCodeTime).getTime() > 5*60*1000){
          this.refreshCode();
          this.functionUse();
        }
      }, 1000*60);
    },
    // 获取校验密码规则
    getRule() {
      getUserRule().then((res) => {
        const data = res.data;
        data.enbleCaptcha=data.enbleCaptcha||0;
        this.$store.dispatch('UserRule', data);
        // MESSAGE 正则提示 CDXZ 最小长度  MMZCGZ 密码组成规则
        let arr=[];
        if(data.BHDXZM==1){  // 包含大写字母
          arr.push("A-Z");
        }
        if(data.BHXXZM==1){  // 包含小写字母
          arr.push("a-z");
        }
        if(data.BHTSZF==1){  // 包含特殊符号
          arr.push("#@!~%^&*.");
        }
        if(data.BHSZ==1){  // 包含数字
          arr.push("\\d");
        }
        let a="",b=""
        for (let i = 0; i < arr.length; i++) {
          const e = arr[i];
          a+=`(?=.*[${e}])`;
          b+= e;
        }
        // /(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]/
        // console.log(new RegExp(`${a}[${b}]`));
        this.loginRules.password=[
          { required: true, message: "请输入密码!"},
          {min: Number(data.CDXZ), message: `密码长度最少为${data.CDXZ}位!`},
        ]
        this.refreshCode();
        if(arr.length>0){
          this.loginRules.password.push({pattern: new RegExp(`${a}[${b}]`),message: data.MESSAGE});
        }
      });
    },
    refreshCode() {
      getCaptcha().then(async (res) => {
        const data = res.data;
        this.form.key = data.key;
        this.form.image = data.image;
        let obj = {...getStore({name:"userRule"}),verCodeTime: new Date().getTime()};
        this.verCode = data.verCode||false;
        this.$store.dispatch('UserRule', obj);
      });
    },
    showPassword() {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    // 点击登录
    handleLogin() {
      console.log(111111);
      console.log(this.userInfo);
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log(getStore({ name: 'token' }));
          let ipHead = this.form.username.split("@");
          if (ipHead.length>1) {this.$store.dispatch("setIpHead", ipHead[1]);}else{this.$store.dispatch("setIpHead", "");}
          if(this.enterNumber>0) return;
          if(getStore({ name: 'token' })){
            this.$confirm(`您已经登录了“${this.userInfo.user_name}(${this.userInfo.user_acc})”的账号，确定要替换为“${this.form.username}”的账号吗？如果“确定”请勿操作当前浏览器的其他标签页面，大概率会造成数据错乱！`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(res=>{
              this.loginfun();
            }).catch(e => {
              this.enterNumber = 0;
            })
          }else{
            this.loginfun();
          }
        }
      });
    },
    // 登录接口
    async loginfun(){
      this.enterNumber++;
      if(this.failures>=this.userRule.enbleCaptcha&&this.verCode!==this.form.code){
        this.$message.error("验证码错误!");
        this.$set(this.form,"code","");
        this.refreshCode();
        this.functionUse();
        this.enterNumber = 0;
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "登录中,请稍后。。。",
        spinner: "el-icon-loading",
      });
      let obj =this.deepClone(this.form);
      let head = {};
      obj.grant_type = "captcha";
      obj.scope= "all";
      head["Tenant-Id"]= obj.tenantId,
      head["Captcha-Key"]= obj.key,
      head["Captcha-Code"]= obj.code,
      delete obj.image;
      delete obj.key;
      delete obj.code;
      console.log(obj);

      //将TEAM_ID存入redis
      await saveTeamIdToRedis(this.form.roleId,this.form.username);

      this.$store
        .dispatch("LoginByUsername", {params:obj,head})
        .then((res) => {
          // let renewal = (this.userInfo.sfmrmm&&this.userRule.sfqzxgmm == "1");
          let renewal = false;
          // this.$store.dispatch("setRenewal", renewal);
          this.$store.dispatch("setRenewal", false);
          this.$store.dispatch("getPersonalization"); // 获取个性化配置
          this.$store.dispatch("setFailures", 0); // 失败次数清零
          this.$router.push({ path: renewal?'/info/index':this.tagWel.value });
          // this.$router.push({ path: this.tagWel.value });
          loading.close();
          this.enterNumber = 0;
          clearInterval(this.time);
        })
        .catch((e) => {
          this.$store.dispatch("setFailures", this.failures+1); // 失败次数+1
          console.log(e);
          this.form.code = "";
          loading.close();
          this.refreshCode();
          this.functionUse();
          this.enterNumber = 0;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.login-form /deep/.el-input input {
  // padding-top: 10px !important;
  height: 40px;
  padding-bottom: 0px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
}
/deep/.el-input__prefix{
  margin-left: 2px;
}
.img{
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
.login-form /deep/.el-select .el-input__inner {
  height: 40px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
}
</style>
